export default {
	common: {
		appTitle: 'Soft AI',
		loading: 'Načítání…',
		loadMore: 'Načíst další',
	},

	language: {
		title: 'Jazyk',
		subtitle: 'Vyberte preferovaný jazyk',
		description:
			'Rozhraní, menu a popisy postav se zobrazí ve zvoleném jazyce. Můžete ho kdykoli změnit.',
		selectLanguage: 'Vyberte jazyk',
		active: 'Aktivní',
		pl: 'Polski',
		plDescription: 'Polské rozhraní a obsah',
		de: 'Deutsch',
		deDescription: 'Německé rozhraní a obsah',
		en: 'English',
		enDescription: 'Anglické rozhraní a obsah',
		cs: 'Čeština',
		csDescription: 'České rozhraní a obsah',
		close: 'Zavřít',
	},

	login: {
		title: 'Soft AI',
		subtitle: 'Najděte svého ideálního společníka.',
		subtitleLogin: 'Zadejte heslo pro pokračování.',
		subtitleSetPassword:
			'Váš účet již existuje. Nastavte si heslo pro přihlášení.',
		subtitleRegister: 'Vytvořte si účet a můžete začít.',
		emailLabel: 'E-mailová adresa',
		emailPlaceholder: 'Zadejte svůj e-mail',
		passwordLabel: 'Heslo',
		passwordPlaceholder: '••••••••',
		passwordSetPlaceholder: 'vytvořte heslo',
		passwordLabelRegister: 'Nastavit heslo',
		confirmPasswordLabel: 'Potvrdit heslo',
		confirmPasswordPlaceholder: 'Potvrďte své heslo',
		loginButton: 'Přihlásit se',
		loggingIn: 'Přihlašování...',
		checkingEmail: 'Kontrola e-mailu...',
		registering: 'Vytváření účtu...',
		loginSuccessButton: 'Přihlášeno',
		registerSuccessButton: 'Účet vytvořen',
		continueButton: 'Pokračovat',
		registerButton: 'Registrovat se',
		setPasswordButton: 'Nastavit heslo',
		forgotPasswordLink: 'Zapomněli jste heslo?',
		registerLink: 'Registrovat se',
		goBackLink: 'Změnit e-mail',
		resetPasswordLink: 'Obnovit heslo',
		resetModalTitle: 'Obnovení hesla',
		resetModalHint: 'Zadejte svůj e-mail a pošleme vám odkaz pro obnovení hesla.',
		sendResetLinkButton: 'Odeslat odkaz pro obnovení',
		resetSending: 'Odesílání...',
		resetBackToLogin: 'Zpět na přihlášení',
		resetSuccessTitle: 'Zkontrolujte e-mail',
		resetSuccessHint: 'Odeslali jsme vám odkaz pro obnovení hesla.',
		resetSuccessMessage:
			'Pokud účet s tímto e-mailem existuje, brzy obdržíte odkaz. Zkontrolujte také složku spam.',
		passwordMismatch: 'Hesla se neshodují.',
		passwordRequirements: 'Alespoň 6 znaků.',
		passwordTooShort: 'Heslo musí mít alespoň 6 znaků.',
		passwordNeedsNumber: 'Heslo musí obsahovat alespoň jednu číslici.',
		passwordNeedsSpecial: 'Heslo musí obsahovat alespoň jeden speciální znak.',
		errorMessage: 'Neplatná e-mailová adresa nebo heslo. Zkuste to znovu.',
		wrongPasswordMessage: 'Nesprávné heslo. Zkuste to znovu.',
		accountExistsLogin: 'Tento účet již existuje. Přihlaste se.',
		showPassword: 'Zobrazit heslo',
		hidePassword: 'Skrýt heslo',
	},

	restartPassword: {
		statusLoading: 'Kontrola',
		statusReady: 'Reset',
		statusSuccess: 'Hotovo',
		statusInvalid: 'Vypršelo',
		loadingTitle: 'Kontrolujeme odkaz',
		loadingMessage: 'Počkej prosím, ověřujeme odkaz pro obnovení hesla.',
		invalidTitle: 'Tento odkaz není platný',
		invalidMessage:
			'Odkaz vypršel nebo už byl použit. Požádej o nový na přihlašovací obrazovce.',
		successTitle: 'Heslo bylo aktualizováno',
		successMessage: 'Nové heslo je připravené. Můžeš se přihlásit do Soft AI.',
		formTitle: 'Nastav nové heslo',
		formMessage: 'Zvol nové heslo k účtu. Odkaz platí 24 hodin.',
		passwordLabel: 'Nové heslo',
		passwordPlaceholder: 'Zadej nové heslo',
		confirmPasswordLabel: 'Potvrď heslo',
		confirmPasswordPlaceholder: 'Zopakuj nové heslo',
		passwordRequirements: 'Alespoň 6 znaků.',
		passwordResetTooShort: 'Heslo musí mít alespoň 6 znaků.',
		passwordMismatch: 'Hesla se neshodují.',
		submitButton: 'Uložit nové heslo',
		submitting: 'Ukládání...',
		backToApp: 'Zpět do Soft AI',
		showPassword: 'Zobrazit heslo',
		hidePassword: 'Skrýt heslo',
		errorGeneric: 'Heslo se nepodařilo změnit. Zkus to znovu.',
	},

	studio: {
		createTitlePrefix: 'Vytvořte si svou',
		createTitleHighlight: 'Softie',
		navigation: 'Navigace Studio',
		back: 'Zpět',
		next: 'Další',
		createSoftie: 'Vytvořit Softie',
		chooseGender: 'Vyberte pohlaví',
		chooseEthnicity: 'Vyberte etnicitu',
		chooseHairstyle: 'Vyberte účes',
		chooseHairColor: 'Vyberte barvu vlasů',
		chooseBodyType: 'Vyberte typ postavy',
		chooseEyeColor: 'Vyberte barvu očí',
		chooseBreastSize: 'Vyberte velikost prsou',
		chooseBulgeSize: 'Vyberte velikost',
		chooseAge: 'Vyberte věk',
		confirmAge: 'Potvrdit',
		ageLabel: 'Věk',
		yearsOld: 'let',
		finalTitle: 'Udělejte ze svého Softie skutečně svého',
		generatingTitle: 'Generování postavy',
		creatingSoftie: 'Vytváříme tvou Softie',
		generatingHint: 'Spojujeme vzhled, atmosféru a hlas v jednu osobnost.',
		generatingPhaseLook: 'Tvarujeme vzhled',
		generatingPhasePersona: 'Tkáme osobnost',
		generatingPhaseAwaken: 'Probuzení',
		generatingPhoto: 'Generování fotky...',
		estimatedPhotoTimeRemaining: 'Odhadovaný čas: {seconds}s',
		estimatedVideoTimeRemaining: 'Skoro hotovo: {seconds}s',
		resultTitle: 'Váš Softie čeká',
		awakenSoftie: 'Probuďte Softie',
		meetMySoftie: 'Poznej svou Softie',
		rerollLook: 'Znovu losovat vzhled',
		name: 'Jméno',
		fieldEthnicity: 'Etnicita',
		fieldAge: 'Věk',
		fieldEyeColor: 'Barva očí',
		fieldBodyType: 'Typ postavy',
		fieldHairstyle: 'Účes',
		fieldHairColor: 'Barva vlasů',
		fieldBreastSize: 'Velikost prsou',
		fieldBulgeSize: 'Velikost',
		personality: 'Osobnost',
		occupation: 'Povolání',
		relationship: 'Vztah',
		nationality: 'Národnost',
		city: 'Město',
		zodiac: 'Znamení zvěrokruhu',
		kinks: 'Preference',
		voice: 'Hlas',
		confirmFinal: 'Potvrdit',
		namePlaceholder: 'Jméno postavy',
		cityPlaceholder: 'Město',
		done: 'Hotovo',
		gridOptionLabels: {},
		gender: {
			chooseGender: 'Vyberte pohlaví',
			woman: 'Žena',
			men: 'Muž',
			trans: 'Trans',
		},
	},

	imageGeneration: {
		title: 'Generátor postav AI',
		subtitle:
			'Oživte svou fantazii: vyberte každý detail, od pohledu až po outfit.',
		characterName: 'Jméno postavy',
		characterNamePlaceholder: 'např. Alexandra, Zoja, Carmen...',
		prompt: 'Prompt',
		promptPlaceholder:
			'např. Blondýna v červených šatech na pozadí nočního města...',
		randomPrompt: 'Nevíte, co napsat? Klikněte pro vygenerování popisu!',
		customization: 'Přizpůsobení postavy',
		numberOfImages: 'Počet obrázků k vygenerování',
		imageCount: '{count} obrázek',
		imagesCount: '{count} obrázků',
		generating: 'Generování...',
		generateCharacter: 'Generovat postavu',
		historyTitle: 'Historie vygenerovaných postav',
		loading: 'Načítání...',
		emojiIconAlt: 'Ikona emoji',
	},

	nav: {
		mainNavigation: 'Hlavní navigace',
		lounge: 'Lounge',
		discover: 'Objevovat',
		chat: 'Chat',
		studio: 'Studio',
		mySofties: 'Moji Softies',
	},

	topBar: {
		sparkBalance: 'Zůstatek Spark',
		openSparkPackages: 'Otevřít balíčky Spark',
		totalBalance: 'Celkový zůstatek',
		account: 'Účet',
		logIn: 'Přihlásit se',
		register: 'Registrovat se',
	},

	authModal: {
		loginTitle: 'Přihlaste se pro pokračování',
		registerTitle: 'Vytvořte si účet',
		loginHint: 'Vítejte zpět. Přihlaste se a začněte chatovat se svými Softies.',
		registerHint: 'Vytvořte si bezplatný účet a odemkněte chat i uložení svých postav.',
		visualTitle: 'Poznejte své Softies',
		visualDescription:
			'Vytvářejte postavy, objevujte styly a odemkněte chat s bezplatným účtem.',
		loginVisualTitle: 'Vítejte zpět',
		loginVisualDescription: 'Přihlaste se a pokračujte tam, kde jste se svými Softies skončili.',
		guestBrowseHint:
			'Prohlížejte postavy zdarma. Přihlaste se nebo se zaregistrujte pro chatování, vytváření Softies a plný přístup.',
		hasAccountPrompt: 'Už máte účet?',
		switchToLogin: 'Přihlásit se',
		noAccountPrompt: 'Ještě nemáte účet?',
		switchToRegister: 'Zaregistrujte se',
		loginAction: 'Přihlásit se',
		registerAction: 'Registrovat se',
		continueBrowsing: 'Pokračovat v prohlížení',
		tabSwitcherLabel: 'Režim přihlášení',
		close: 'Zavřít',
	},

	sparkModal: {
		premiumAccess: 'Prémiový přístup',
		premiumDescription:
			'Dobijte Sparky pro generování obrázků, videí a jedinečných momentů bez čekání.',
		closeSparkPackages: 'Zavřít balíčky Spark',
		selectPackage: 'Vyberte balíček',
		usageTitle: 'Jak se Sparky využívají:',
		messageUsage: 'Zpráva:',
		messageUsageValue: '0 Sparků',
		voiceUsage: 'Hlas:',
		voiceUsageValue: '0 Sparků',
		photoUsage: 'Fotografie:',
		photoUsageValue: '5 Sparků',
		videoUsage: 'Video:',
		videoUsageValue: '50 Sparků',
		characterUsage: 'Vytvoření postavy:',
		characterUsageValue: '100 Sparků',
		sparkPackages: 'Balíčky Spark',
		termsOfService: 'Podmínky služby',
		privacyPolicy: 'Zásady ochrany soukromí',
		acceptTermsPrefix: 'Souhlasím s',
		acceptTermsAnd: 'a',
		selectPackageButton: 'Vyberte balíček',
		continueWithPrice: 'Pokračovat ({price})',
		packages: {
			basic: {
				name: 'BASIC',
				sparks: '1000 Sparků',
			},
			pro: {
				name: 'PRO',
				sparks: '3000 Sparků',
			},
			premium: {
				name: 'PREMIUM',
				sparks: '6000 Sparků',
			},
		},
	},

	profileAccount: {
		account: 'Účet',
		displayName: 'Zobrazované jméno',
		nameRequired: 'Zobrazované jméno je povinné.',
		nameSaveError: 'Zobrazované jméno se nepodařilo uložit. Zkuste to znovu.',
		tokens: 'Tokeny',
		planValidUntil: 'Plán platný do',
		memberSince: 'Člen od:',
		support: 'Podpora: support@softai.today',
		supportLabel: 'Podpora',
		supportEmail: 'support@softai.today',
		logOut: 'Odhlásit se',
		loggingOut: 'Odhlašování...',
		privacyPolicy: 'Zásady ochrany soukromí',
		termsOfUse: 'Podmínky použití',
	},

	home: {
		stories: 'Příběhy',
		previousStories: 'Předchozí příběhy',
		nextStories: 'Další příběhy',
		storyClose: 'Zavřít příběh',
		storyPrev: 'Předchozí příběh',
		storyNext: 'Další příběh',
		storyPlay: 'Přehrát',
		storyPause: 'Pozastavit',
		storyTimeAgo: '5h',
		storyReplyPlaceholder: 'Napište zprávu...',
		storyReplySend: 'Odeslat',
		loungeHighlight: 'Výběr Lounge',
		loungeTitlePrefix: 'Vyberte si svou',
		loungeTitleSoftie: 'Softie',
		loungeTitleMiddle: ', následujte',
		loungeTitleVibe: 'atmosféru',
		surpriseMe: 'Překvap mě',
		loungeCategories: 'Kategorie Lounge',
		previousCategories: 'Předchozí kategorie',
		nextCategories: 'Další kategorie',
		categoriesLabel: 'Kategorie',
		all: 'Vše',
		loadingTags: 'Načítání tagů…',
		categories: {
			Neighbor: 'Sousedka',
			Romantic: 'Romantická',
			Sweet: 'Sladká',
			Naughty: 'Nezbedná',
			Mature: 'Zralá',
			Luxury: 'Luxusní',
			Fitness: 'Sportovní',
			Bossy: 'Dominantní',
			Nerdy: 'Nerdy',
			Trans: 'Trans',
			Mystic: 'Mystická',
			Fantasy: 'Fantasy',
			Men: 'Muži',
		},
	},

	discover: {
		ariaLabel: 'Objevovat postavy',
		back: 'Zpět do Lounge',
		swipeHint: 'Přejeďte nahoru pro další',
		loadingProfiles: 'Načítání postav...',
	},

	mySofties: {
		titlePrefix: 'Moji',
		titleHighlight: 'Softies',
		createSoftie: 'Vytvoř svou Softie',
	},

	profileModal: {
		close: 'Zavřít profil',
		characterGallery: 'Galerie postavy',
		previousPhoto: 'Předchozí fotografie',
		nextPhoto: 'Další fotografie',
		photoNumber: 'Fotografie {number}',
		startChatting: 'Začít chatovat',
		meta: '{age} let · {origin}',
		defaultOrigin: 'Neznámé',
		personalityAttributes: 'Osobnostní vlastnosti',
		physicalAttributes: 'Fyzické vlastnosti',
		occupation: 'Povolání',
		relationship: 'Vztah',
		kinks: 'Preference',
		ethnicity: 'Etnicita',
		country: 'Země',
		age: 'Věk',
		bodyType: 'Typ postavy',
		zodiacSign: 'Znamení zvěrokruhu',
		unknown: 'Neznámé',
		defaultOccupation: 'Společník',
		defaultRelationship: 'Singl',
		defaultZodiac: 'Váhy',
		defaultKinks: 'Škádlení',
	},

	profileCard: {
		portraitAlt: 'Portrét {name}',
		regenerateImage: 'Znovu vygenerovat obrázek',
		ageShort: 'let',
	},

	chat: {
		conversationPanel: 'Panel konverzace',
		companionProfile: 'Profil společníka',
		loadingTitle: 'Načítání konverzace...',
		loadingText: 'Načítání uživatelských a chatových dat. Chvíli prosím počkejte.',
		noConversationTitle: 'Není vybrána žádná konverzace',
		noConversationText:
			'Vyberte existující konverzaci ze seznamu nebo začněte novou, abyste mohli chatovat.',
		online: 'Online',
		back: 'Zpět',
		generatingImage: 'Generování obrázku...',
		generatingVideo: 'Příprava videa...',
		estimatedTimeRemaining: 'Odhadovaný zbývající čas: {seconds}s',
		estimatedTextTimeRemaining: 'Odhadovaný čas: {seconds}s',
		estimatedVideoTimeRemaining: 'Téměř hotovo: {seconds}s',
		writeMessage: 'Napište zprávu...',
		sendMessage: 'Odeslat zprávu',
		sendMePhoto: 'Pošli mi fotku',
		sendMeVideo: 'Pošli mi video',
		call: 'Zavolat',
		endCall: 'Ukončit hovor',
		callInProgress: 'Probíhá hovor',
		voiceCallActive: 'Hlasový hovor aktivní',
		voiceCallStartSpeaking: 'Začni mluvit...',
		voiceCallSpeaking: 'Mluví...',
		voiceCallYouSpeaking: 'Mluvíš...',
		voiceCallProcessing: 'Připojování odpovědi...',
		callMessage: 'Ahoj, jsi tam?',
		videoReply: 'Jasně, tady je tvé video.',
		videoNotAvailable: 'Video pro tohoto společníka zatím není k dispozici.',
		fetchMessagesError:
			'Při načítání zpráv se něco pokazilo. Zkuste to znovu.',
		illegalContentError:
			'Vaše zpráva není povolena. Tento obsah nemůžeme vygenerovat.',
		noTokensError: 'Došly Sparky! Dobijte si je, abyste mohli pokračovat.',
		imageGenerationError:
			'Obrázek se nepodařilo vygenerovat. Zkuste to prosím za chvíli znovu.',
		videoGenerationError:
			'Video se nepodařilo vygenerovat. Zkuste to prosím za chvíli znovu.',
		guestGateTitle: 'Zaregistrujte se a začněte chatovat',
		guestGateDescription:
			'Vytvořte účet, vyberte plán a během chvilky začněte mluvit se svou Softie.',
		guestGateHeroTitle: 'Váš Softie čeká',
		guestGateHeroDescription:
			'Zaregistrujte se a odemkněte chat, fotky a personalizované chvíle.',
		guestGateRegister: 'Registrace',
		guestGateLogin: 'Už mám účet',
		planPaywallTitle: 'Vyberte svůj plán',
		planPaywallDescription: 'Plný přístup k chatu a tvorbě obsahu.',
		planPaywallBenefitUncensored: 'Rozhovory bez cenzury a omezení',
		planPaywallBenefitPrivatePhotos: 'Exkluzivní soukromé fotografie',
		planPaywallBenefitPriorityAi: 'Prioritní zpracování AI',
		planPaywallHeroTitle: 'Prémiový přístup',
		planDurationBasic: '1 měsíc plného přístupu',
		planDurationPro: '3 měsíce plného přístupu',
		planDurationPremium: '6 měsíců plného přístupu',
		planPaywallSelectPlan: 'Vyberte plán',
		planPaywallContinue: 'Pokračovat ({price})',
		planPaywallPopular: 'Oblíbený',
		planCheckoutSectionEyebrow: 'Pokladna',
		planCheckoutSectionTitle: 'Platební údaje',
		planCheckoutSectionSubtitle: 'Vyberte metodu a dokončete nákup',
		planCheckoutSelectedPlan: 'Vybraný plán',
		planCheckoutClose: 'Zavřít výběr plánu',
		planCheckoutCompleteTitle: 'Dokončit platbu',
		planCheckoutOneOffSubtitle: 'Bezpečná platba přes Stripe.',
		planCheckoutSubscriptionSubtitle:
			'Bezpečné měsíční předplatné přes Stripe. Zadejte údaje karty níže.',
		planCheckoutRecurring: 'Opakovaná platba • Zrušení kdykoli',
		planCheckoutProcessing: 'Zpracování...',
		planCheckoutCreatingSubscription: 'Vytvářím předplatné...',
		orderStatusVerifyingPayment: 'Ověřuji platbu...',
		orderStatusPillVerifying: 'Ověření',
		orderStatusPillSuccess: 'Úspěch',
		orderStatusPillFailed: 'Chyba',
		orderStatusRedirecting: 'Za chvíli přesměrujeme...',
		orderStatusVerifyingPaymentDescription:
			'Potvrzujeme vaši platbu. Může to trvat až 2 minuty.',
		orderStatusPaymentSuccess: 'Plán zaplacen!',
		orderStatusPaymentSuccessDescription:
			'Vaše předplatné je aktivní. Za chvíli budete přesměrováni.',
		orderStatusTokensSuccess: 'Sparky dobité!',
		orderStatusTokensSuccessDescription:
			'Platba potvrzena. Za chvíli se vrátíte zpět.',
		orderStatusPaymentFailed: 'Platba se nezdařila',
		orderStatusPaymentFailedDescription:
			'Platbu se nepodařilo potvrdit. Zkuste to znovu nebo kontaktujte podporu.',
		orderStatusPaymentTimeout:
			'Platbu se nepodařilo potvrdit do 2 minut. Zkuste to prosím znovu.',
		orderStatusBackToCheckout: 'Zpět k platbě',
		orderStatusGoToLogin: 'Přejít na přihlášení',
		planCheckoutSubscribe: 'Předplatit ({price})',
		planCheckoutPaymentLabel: 'Platební metoda',
		planCheckoutCardLabel: 'Údaje o kartě',
		planCheckoutSubscribeTermsPrefix: 'Předplacením souhlasíte s',
		planCheckoutPay: 'Zaplatit {price}',
		planCheckoutTermsPrefix: 'Dokončením nákupu souhlasíte s',
		planCheckoutTermsLink: 'Podmínkami použití',
		planCheckoutTermsAnd: 'a',
		planCheckoutPrivacyLink: 'Zásadami ochrany osobních údajů',
		planCheckoutSecureStripe: 'Stripe · šifrované · bezpečné',
		planCheckoutBadge: 'Premium',
		planCheckoutLoadingPayment: 'Načítání platebního formuláře...',
		planCheckoutPaymentError: 'Platbu se nepodařilo spustit. Zkuste to znovu.',
		planCheckoutStripeMissing: 'Chybí Stripe public key (VITE_STRIPE_PUBLIC_KEY).',
		planCheckoutLoginRequired: 'Pro zaplacení plánu se prosím přihlaste.',
		tokensExhaustedTitle: 'Došly vám Sparky',
		tokensExhaustedDescription:
			'Dobijte Sparky, abyste mohli pokračovat v chatu a generovat nový obsah.',
		tokensExhaustedHeroTitle: 'Dobít Sparky',
		tokensExhaustedHeroDescription:
			'Vyberte balíček Sparků a vraťte se do chatu bez přerušení.',
		generatedImageAlt: 'Vygenerovaný obrázek',
		generatedVideoAlt: 'Vygenerované video',
		videoLoadError: 'Video se nepodařilo načíst. Obnovte stránku a zkuste to znovu.',
		feedbackActionsLabel: 'Zpětná vazba',
		feedbackLikeTitle: 'Co se vám na této odpovědi líbilo?',
		feedbackDislikeTitle: 'Co bychom měli zlepšit?',
		feedbackDislikePlaceholder: 'Povinné: Popište problém (min. 5 znaků)',
		feedbackOptionalPlaceholder: 'Vaše zpětná vazba (volitelné)',
		feedbackSkip: 'Přeskočit',
		feedbackSubmit: 'Odeslat',
		feedbackSending: 'Odesílání...',
		feedbackMinLengthHint:
			'Napište zprávu (min. 5 znaků) nebo stiskněte „Přeskočit" pro odeslání zpětné vazby bez textu.',
		feedbackHint:
			'Můžete zanechat krátkou zprávu nebo přeskočit a zavřít okno.',
		feedbackSkippedText: 'Text nebyl zadán (přeskočeno)',
		messageActionsLabel: 'Akce zprávy',
		tooltipLike: 'Líbí se',
		tooltipDislike: 'Ke zlepšení',
		tooltipListen: 'Poslechnout',
		listenToMessage: 'Poslechnout zprávu',
		speakLoading: 'Načítání hlasu...',
		speakStop: 'Zastavit přehrávání',
		speakError: 'Při přehrávání hlasu se něco pokazilo. Zkuste to znovu.',
		galleryClose: 'Zavřít',
		galleryPrev: 'Předchozí',
		galleryNext: 'Další',
		galleryError: 'Chyba při načítání obrázku',
		hide: 'Skrýt',
		showChatList: 'Zobrazit seznam chatů',
		hideChatList: 'Skrýt seznam chatů',
		showProfilePanel: 'Zobrazit panel profilu',
		hideProfilePanel: 'Skrýt panel profilu',
		more: 'Více',
		imagesCount: 'Obrázky a videa ({count})',
		imagesLabel: 'Obrázky',
		noImagesYet: 'V této konverzaci zatím nebyly vygenerovány žádné obrázky.',
		imagePlaceholder: 'Další moment přistane sem',
		archiveConversation: 'Archivovat konverzaci s {name}',
		deleteConversationTitle: 'Smazat konverzaci?',
		deleteConversationWarning: 'Tuto akci nelze vrátit zpět.',
		deleteConversationDeleting: 'Mazání...',
		deleteConversationDeleted: 'Smazáno',
		deleteConversation: 'Smazat konverzaci',
		no: 'Ne',
		yes: 'Ano',
		newChat: 'Nový chat',
		search: 'Hledat',
		searchPlaceholder: 'Hledat konverzace...',
		loadingConversations: 'Načítání konverzací',
		noConversationsYet: 'Zatím žádné konverzace.',
		profileInfoAria: 'Informace o profilu {name}',
		thinking: 'Přemýšlím',
		typing: 'Píše',
		processingMessage: 'Zpracování zprávy...',
		cancelRecording: 'Zrušit',
		noDescription: 'Pro tento profil není k dispozici podrobný popis.',
		newChatModalTitle: 'Vyberte si svého partnera!',
		newChatModalLoading: 'Načítání partnerů',
		newChatModalNoPersons: 'Žádní partneři nejsou k dispozici.',
	},

	audioError: {
		title: 'Problém s mikrofonem',
		subtitle:
			'Nepodařilo se získat přístup k mikrofonu. Zkontroluj připojení zařízení a oprávnění prohlížeče.',
		deniedSubtitle:
			'Přístup k mikrofonu byl zablokován. Povol mikrofon pro tuto stránku v nastavení prohlížeče.',
		notFoundSubtitle:
			'Mikrofon nebyl nalezen. Připoj audio zařízení nebo zkontroluj nastavení systému.',
		inUseSubtitle:
			'Mikrofon používá jiná aplikace. Zavři ji a zkus to znovu.',
		unsupportedSubtitle:
			'Tvůj prohlížeč nepodporuje nahrávání hlasu v této aplikaci.',
		timeoutSubtitle:
			'Vypršel časový limit pro přístup k mikrofonu. Zkontroluj oprávnění a zkus to znovu.',
		unknownSubtitle:
			'Došlo k neočekávanému problému s mikrofonem. Zkontroluj zařízení a oprávnění.',
		mimeTypeUnsupportedSubtitle:
			'Tvůj prohlížeč nepodporuje nahrávání zvuku. Zkus použít Chrome, Safari nebo Firefox.',
		checkPerms: 'Jak povolit mikrofon:',
		guides: {
			chrome: 'Google Chrome',
			safari: 'Safari',
			mac: 'macOS',
			iphone: 'iPhone / iPad',
		},
		or: 'nebo',
		mobileCta: 'Můžeš také použít mobilní aplikaci:',
		android: 'Android',
		ios: 'iOS',
		retry: 'Obnovit stránku',
		tipRefresh:
			'Po změně oprávnění obnov stránku a zkus hovor spustit znovu.',
	},

	currency: { symbol: 'Kč', code: 'czk' },
	promoPlan: {
		name: 'PREMIUM',
		title: '6 měsíců',
		discount: '80%',
		prev: '3595',
		current: '719',
		daily: '3.99',
		popular: true,
		type: 'PREMIUM',
	},
	plans: [
		{
			name: 'PREMIUM',
			title: '6 měsíců',
			discount: '70%',
			prev: '3633',
			current: '1090',
			daily: '6.06',
			popular: true,
			type: 'PREMIUM',
		},
		{
			name: 'PRO',
			title: '3 měsíce',
			discount: '60%',
			prev: '1748',
			current: '699',
			daily: '7.77',
			popular: false,
			type: 'PRO',
		},
		{
			name: 'BASIC',
			title: '1 měsíc',
			discount: '40%',
			prev: '582',
			current: '349',
			daily: '11.63',
			popular: false,
			type: 'BASE',
		},
	],
};
